import React from 'react'

export const useContext = <T>(ctxt: React.Context<T>): T => {
  if (ctxt == null) {
    throw new Error('Context was not provided!')
  }

  const context = React.useContext(ctxt)

  return context
}
